import React, { useState, useEffect, useRef } from 'react';
import { sanitizeHtml } from '../../utils/Tools';

interface IModalProps {
  setModalOpen: Function;
  className?: string;
  title?: string;
  header?: JSX.Element;
  children?: React.ReactNode;
  size?: 'm' | 'l' | 'xl' | 'xxl' | 'full';
  noClose?: boolean;
  noCloseOnBackgroundClick?: boolean;
}

const Modal = (props: IModalProps) => {
  const [sizeClassName, setSizeClassName] = useState<string>('');
  // True only when this gesture's mousedown hit the backdrop, not the dialog.
  const backdropPress = useRef(false);

  const closeModal = () => {
    if (props.noClose) return;

    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === 'function') {
      active.blur();
    }

    props.setModalOpen(false);
  };

  useEffect(() => {
    //set body as no scroll

    document.querySelector('body')?.classList.add('modal-open');
    return () => {
      //remove class from body
      window.setTimeout(() => {
        let nodes = document.querySelectorAll('.modal-not-bs');
        if (nodes.length === 0) {
          document.querySelector('body')?.classList.remove('modal-open');
        }
      }, 100);
    };
  }, []);

  useEffect(() => {
    let value = '';
    switch (props.size) {
      case 'm':
        value = `modal-m`;
        break;
      case 'l':
        value = `modal-l`;
        break;
      case 'xl':
        value = `modal-xl`;
        break;
      case 'xxl':
        value = `modal-xxl`;
        break;

      case 'full':
        value = `modal-full`;
        break;
    }
    setSizeClassName(value);
  }, [props.size]);

  const handleBackdropMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    backdropPress.current = e.button === 0 && e.target === e.currentTarget;
  };

  const handleBackdropMouseUp = (e: React.MouseEvent<HTMLDivElement>) => {
    const startedOnBackdrop = backdropPress.current;
    backdropPress.current = false;
    // A click on the background must both start and end there. Releasing
    // outside after selecting text in the dialog is not that click.
    if (!startedOnBackdrop || e.button !== 0 || e.target !== e.currentTarget) return;
    if (props.noCloseOnBackgroundClick || !props.setModalOpen) return;
    e.stopPropagation();
    closeModal();
  };

  return (
    <div
      className="modal-not-bs"
      id="modal"
      onMouseDown={handleBackdropMouseDown}
      onMouseUp={handleBackdropMouseUp}>
      <div className={`x-modal-content ${sizeClassName} ${props.className}`}>
        <div className="x-modal-header">
          {props.title && <h3 dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.title) }}></h3>}
          {props.header && <div>{props.header}</div>}
          {!props.noClose && (
            <span
              className="click close-button text-danger"
              onClick={() => {
                closeModal();
              }}>
              <i className="far fa-times-circle larger"></i>
            </span>
          )}
        </div>
        <div className="x-modal-body">{props.children || 'add children'}</div>
      </div>
    </div>
  );
};

export default Modal;
